module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTkyOCAzNTJhMzIgMzIgMCAwIDEgMzIgMzJ2NDgwYTMyIDMyIDAgMCAxLTMyIDMySDk2YTMyIDMyIDAgMCAxLTMyLTMyVjM1Mmg4NjR6TTM2NS45IDEyOGEzMiAzMiAwIDAgMSAyNy40IDE1LjZMNDgwIDI4OEg2NFYxNjBhMzIgMzIgMCAwIDEgMzItMzJoMjY5Ljl6IiBmaWxsPSIjMCIgcC1pZD0iNDg2NiI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Folder-filled.svg
// module id = wzv1
// module chunks = 74